(function(){
    'use strict';
    angular.module('Services').factory('ServiceProfilePreviewTableService', ServiceProfilePreviewTableService);
    ServiceProfilePreviewTableService.$inject = [
        'TableLiteFactory', 
        'Location'
    ];

    function ServiceProfilePreviewTableService(
        TableLiteFactory, 
        Location
    ) {
        return function (tableData, clientService){
            let service = clientService;
            let tableStructure = {
                config: {
                    noFooter: true,
                    noExtraction: true,
                    noTopOptions: true,
                },
                headers: [{
                    label: 'Country',
                    viewName: 'countryObj'
                }, {
                    label: 'Postcode Range Min',
                    viewName: 'postcodeMin'
                }, {
                    label: 'Postcode Range Max',
                    viewName: 'postcodeMax'
                }, {
                    label: 'Fixed Margin',
                    viewName: 'fixedMargin'
                }, {
                    label: 'Margin %',
                    viewName: 'percentMargin'
                }],
                data: [],
                onInit: ()=>{
                    buildTableData(tableData, clientService, true);
                }
            };

            function buildTableData(items, clientService) {
                service = clientService;
                tableStructure.isFetching = true;
                Location.Country({
                    // name: model
                }, function (data) {
                    tableStructure.countries = data;
                    tableStructure.data.length = 0;
                    angular.forEach(items, function (row, index) {
                        row.countryObj = data.find(country=>row.country === country.code).name;
                        row.fixedMargin = row.marginFixed;
                        row.percentMargin = row.percentMargin
                        row.postcodeMin = row.postcodeRangeStart,
                        row.postcodeMax = row.postcodeRangeEnd
                        tableStructure.data.push(row);
                    });
                    tableStructure.isFetching = false;
                }, function (err) {
                   toastr.error('Unable to fetch countries', err.message)
                });
            }

            this.tableData = tableStructure;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/ServiceProfilePreviewTableService.js